import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import { CustomerAddress, DocumentDate, Footer, Header, theme } from '../../document/Document'

const useStyles = createUseStyles(theme)

const Intervention = ({ document_param: intervention, company_param: company, logo_param: logo }) => {
  const customer = intervention.customer
  const classes = useStyles()

  const References = () => {
    if (intervention) {
      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence intervention</Typography>
            <Typography className={classes.address}>{intervention.intervention_number}</Typography>
          </Box>
        </>
      )
    }
  }

  const InterventionSubject = () => (
    <Box>
      <Box className={classes.mt}>
        <Typography className={classes.bold}>{intervention.summary}</Typography>
      </Box>
      {intervention.material !== undefined && intervention.material !== null && intervention.material !== '' && (
        <Box className={classes.mt}>
          <Typography className={classes.address}>Matériel :</Typography>
          <Typography className={classes.address}>{intervention.material}</Typography>
        </Box>
      )}
      <Box className={classes.mt}>
        <Typography className={classes.address}>Description :</Typography>
        <Typography className={classes.address}>{intervention.description}</Typography>
      </Box>
      {intervention.solution !== undefined && intervention.solution !== null && intervention.solution !== '' && (
        <Box className={classes.mt}>
          <Typography className={classes.address}>Solution :</Typography>
          <Typography className={classes.address}>{intervention.solution}</Typography>
        </Box>
      )}
    </Box>
  )

  const InterventionPayment = () => (
    <Box className={classes.mt}>
      <Typography className={classes.conditions}>
        Ce document ne vaut pas facture. La facture vous sera envoyée ultérieurement.
      </Typography>
    </Box>
  )

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header logo={logo} classes={classes} documentTitle={'INTERVENTION'} />
        <References />
        <DocumentDate date={intervention.intervention_date} classes={classes} />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <InterventionSubject />
        <InterventionPayment />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default Intervention
